export default "__VITE_ASSET__DjbrpXvR__"